module.exports = __webpack_public_path__ + "static/media/eyeflow_inspection_logo_R_no_eye.d9787498.png";